<template>
    <div
        class="favorites-map-card w-full bg-white rounded-lg flex-col justify-start items-start flex"
    >
        <PropertyCardSmall
            :widgetView="false"
            :property="property"
            cardType="map"
        />
        <div
            class="self-stretch h-full pt-8 flex-col justify-start items-start flex"
        >
            <div
                class="self-stretch pb-3 justify-start items-center gap-6 flex"
            >
                <div
                    class="grow shrink basis-0 text-slate-800 text-sm font-medium leading-tight"
                >
                    Pay with points
                </div>
            </div>
            <div
                class="self-stretch justify-start items-start gap-2.5 relative flex"
            >
                <div
                    class="transition-all grow shrink basis-0 justify-start flex-col w-full items-start flex"
                >
                    <!-- START BOOKING INFO CONTAINER: MY POINTS -->
                    <BookingInfoContainer
                        :heading="`My ${$filters.ucWords(property.program?.name)} Points`"
                        width="100%"
                    >
                        <PropertyCardMyPoints
                            :programImage="property.program?.image"
                            :pointsForProgram="pointsForProgram"
                            orientation="vertical"
                        />
                    </BookingInfoContainer>
                    <!-- END BOOKING INFO CONTAINER: MY POINTS -->
                    <!-- START PLUS GRAPHIC -->
                    <div
                        class="relative flex items-center justify-center pt-1 w-full"
                        aria-hidden="true"
                    >
                        <div
                            class="absolute w-10 h-10 bg-white rounded-full shadow border border-slate-200 justify-center items-center gap-2.5 flex text-slate-500"
                        >
                            <i class="fa-duotone fa-plus"></i>
                        </div>
                    </div>
                    <!-- END PLUS GRAPHIC -->
                    <!-- START BOOKING INFO CONTAINER: ADDITIONAL OPTIONS -->
                    <BookingInfoContainer
                        heading="Transfer Partner Options"
                        width="100%"
                    >
                        <PropertyCardTransferOptions
                            v-if="filteredUserPoints.length"
                            :programName="
                                $filters.ucWords(property.program?.name)
                            "
                            :programImage="property.program?.image"
                            :sourceProgramUserPoints="filteredUserPoints"
                            orientation="vertical"
                        />
                        <p v-else class="text-slate-500 text-sm font-normal">
                            None of your current points transfer to
                            {{ $filters.ucWords(property.program?.name) }}.
                        </p>
                    </BookingInfoContainer>
                    <!-- END BOOKING INFO CONTAINER: ADDITIONAL OPTIONS -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import PropertyCardSmall from '@/components/hotels/favorites/property-card-small/property-card-small.vue';
import PropertyCardMyPoints from '@/components/hotels/search/property-card/property-card-my-points/property-card-my-points.vue';
import PropertyCardTransferOptions from '@/components/hotels/search/property-card/property-card-transfer-options.vue';
import BookingInfoContainer from '@/components/hotels/booking-info-container/booking-info-container.vue';
import { useRewardsAndTransferPartners } from '@/composables/useRewardsAndTransferPartners.vue';
import { usePointsStore } from '@/store/points';
export default {
    name: 'PointsInfoCard',
    components: {
        PropertyCardSmall,
        BookingInfoContainer,
        PropertyCardMyPoints,
        PropertyCardTransferOptions,
    },
    props: {
        property: Object,
    },
    setup(props) {
        const pointsStore = usePointsStore();
        const { filterUserPoints } = useRewardsAndTransferPartners();

        const pointsForProgram = computed(() => {
            return pointsStore.filterDataByProgramId(props.property.program.id);
        });

        const filteredUserPoints = computed(() => {
            return filterUserPoints(props.property.program.id);
        });

        return { filteredUserPoints, pointsForProgram };
    },
};
</script>
